import { GetUsersGetRequestModel } from "@/features/user/services/get-users-model";
import { GetUsersApi } from "@/features/user/services/get-users-api";

// 利用者情報取得処理
export class GetUsersService {
  private getUsersApi = new GetUsersApi();
  /**
   * 利用者情報取得API実行
   */
  public async getUsers(param: GetUsersGetRequestModel) {
    return await this.getUsersApi.getUsers(param);
  }
}
